import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CONFIG } from '../../config/config';
import './ComingSoon.css';

const ComingSoon = () => {
  const [params] = useSearchParams();
  const cat = params.get('category') || 'collection';

  return (
    <div className="coming-soon-page page-transition">
      <div className="container coming-soon-inner">
        {CONFIG.UI.SHOW_COMING_SOON && (
          <>
            <p className="coming-soon-label">Coming soon</p>
            <h1 className="coming-soon-title">
              {cat.replace(/-/g, ' ')}
            </h1>
            <p className="coming-soon-copy">
              This category is not available yet. Shop T-Shirts while we prepare the drop.
            </p>
            <Link to="/products?category=t-shirts" className="coming-soon-cta">
              Shop T-Shirts
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default ComingSoon;
